import React from "react";
import { Box } from '@mui/material';
import PrimarySearchAppBar from "../components/PrimarySearchAppBar";

export const CallbackPage = () => {
  return (
    <Box>
      <PrimarySearchAppBar />
      <Box>
	callback page
      </Box>
    </Box>
  );
};